// Đưa dữ liệu GraphQL (projectConfig) về đúng DTO REST cũ mà các component ProjectType đang dùng.
const userRef = (value) => (value ? { id: value.id, name: value.name } : null);

const pageMeta = (pagination, page, size) => {
  const limit = Number(pagination?.limit) || size || 0;
  const offset = Number(pagination?.offset) || 0;
  return {
    total: Number(pagination?.total) || 0,
    page: limit ? Math.floor(offset / limit) + 1 : page || 1,
    size: limit,
  };
};

export const convertProjectType = (value) =>
  value
    ? {
        id: value.id,
        name: value.name,
        shortDescription: value.shortDescription ?? null,
        displayOrder: value.displayOrder,
        displayPlace: value.displayPlace,
        isVisible: value.isVisible,
        icon: value.icon ?? null,
        visiblePackageTierCount: value.visiblePackageTierCount,
        updatedAt: value.updatedAt,
        updatedBy: userRef(value.updatedBy),
      }
    : null;

export const convertProjectTypePage = (value, { page, size } = {}) => ({
  items: (value?.items || []).map(convertProjectType),
  ...pageMeta(value?.pagination, page, size),
});

export const convertProjectQuestion = (value) =>
  value
    ? {
        id: value.id,
        projectTypeId: value.projectTypeId,
        label: value.label,
        answerType: value.answerType,
        isRequired: value.isRequired,
        unit: value.unit ?? null,
        options: value.options || [],
        placeholder: value.placeholder ?? null,
        displayOrder: value.displayOrder,
        isMainQuantity: value.isMainQuantity,
      }
    : null;

export const convertProjectQuestions = (items) => (items || []).map(convertProjectQuestion);

export const convertProjectPackageItem = (value) =>
  value
    ? {
        id: value.id,
        projectTypeId: value.projectTypeId,
        budgetTier: value.budgetTier,
        name: value.name,
        title: value.title,
        shortDescription: value.shortDescription ?? null,
        priceFromMillion: value.priceFromMillion ?? null,
        priceToMillion: value.priceToMillion ?? null,
        priceNote: value.priceNote ?? null,
        isVisible: value.isVisible,
        productCount: value.productCount,
        version: value.version,
        updatedAt: value.updatedAt,
        updatedBy: userRef(value.updatedBy),
      }
    : null;

export const convertProjectPackages = (items) => (items || []).map(convertProjectPackageItem);

export const convertPackageProduct = (value) => ({
  productId: value.productId,
  productName: value.productName,
  model: value.model ?? null,
  imageUrl: value.imageUrl ?? null,
  quantity: value.quantity,
  unitPrice: value.unitPrice,
  lineTotal: value.lineTotal,
  displayLabel: value.displayLabel ?? null,
  displayOrder: value.displayOrder,
});

export const convertProjectPackageDetail = (value) =>
  value
    ? {
        ...convertProjectPackageItem(value),
        projectTypeName: value.projectTypeName,
        products: (value.products || []).map(convertPackageProduct),
        totalProductValue: value.totalProductValue,
      }
    : null;

export const convertCatalogProduct = (value) => ({
  productId: value.productId,
  productName: value.productName,
  model: value.model ?? null,
  imageUrl: value.imageUrl ?? null,
  unitPrice: value.unitPrice,
});

export const convertCatalogProductPage = (value, { page, size } = {}) => ({
  items: (value?.items || []).map(convertCatalogProduct),
  ...pageMeta(value?.pagination, page, size),
});
